'use strict';

var Stringifier = require('./stringifier');
function stringify(node, builder) {
  var str = new Stringifier(builder);
  str.stringify(node);
}
module.exports = stringify;
stringify.default = stringify;